module.exports = __webpack_public_path__ + "img/pic.08935c25.jpg";